import { useTranslation } from "react-i18next";
import { NavLink, Route, Routes } from "react-router";
import "./Account.scss";
import Profile from "./Profile/Profile";
import Security from "./Security/Security";
import Preferences from "./Preferences/Preferences";

function Account() {
  const { t } = useTranslation(["translation", "profile"]);

  return (
    <main>
      <div className="container mt-4">
        <nav className="nav nav-borders">
          {/* Absolute targets: relative links would resolve against the current
              URL and, because Account sits under a splat route, each click would
              append the segment (…/profile/security/profile/…) instead of
              switching tabs. */}
          <NavLink className={"nav-link"} to="/application/account/profile">
            {t("profile", { ns: "account" })}
          </NavLink>
          <NavLink className={"nav-link"} to="/application/account/security">
            {t("secruity", { ns: "account" })}
          </NavLink>
          <NavLink className={"nav-link"} to="/application/account/preferences">
            {t("companyLogo", { ns: "account" })}
          </NavLink>
        </nav>
        <hr className="mt-0 mb-4" />
        <div className="row">
          <div className="col-xl-8">
            <Routes>
              <Route index element={<Profile />} />
              <Route path="/profile/*" element={<Profile />} />
              <Route path="/security/*" element={<Security />} />
              <Route path="/preferences/*" element={<Preferences />} />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Account;
